/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { AxiosError } from 'axios';
import axios from 'axios';
import * as qs from 'query-string';

const paramsSerializer = (params: { [key: string]: any }): string => qs.stringify(params);

export const axiosDefaults = {
  headers: {
    'Cache-control': 'no-store',
    'client-name': 'identity',
    Expires: 0,
    Pragma: 'no-cache',
    'X-Requested-With': 'XMLHttpRequest',
  },
  paramsSerializer,
};

const axiosInstance = axios.create(axiosDefaults);

axiosInstance.interceptors.response.use(
  response => response,
  (error: AxiosError) => {
    const responseData = error.response?.data as Record<string, unknown> | undefined;
    if (error.response?.status === 401 && responseData?.location) {
      window.location.replace(responseData.location as string);
    }
    return Promise.reject(error);
  },
);

export const baseRequest = axiosInstance;
